/**
 * @file: ErpSyncResult.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpSyncResult {
  Success = 'success',
  Failed = 'failed',
}

export const ErpSyncResultValueSet = new Set([
  ErpSyncResult.Success,
  ErpSyncResult.Failed,
]);
